import React from "react";
import CustomMultipleResourcePage from "../components/CustomMultipleResourcePage";
import { Container } from "@amzn/awsui-components-react";

const ACResourcesPage = ({selectedCPView, viewAccess, addOrEditAccess, resetHref}) => (
  <Container>
    <CustomMultipleResourcePage
        pageType="AC RESOURCES"
        tabType="LIST"
        owner={selectedCPView}
        viewAccess={viewAccess}
        addOrEditAccess={addOrEditAccess}
        resetHref={resetHref}
      />
  </Container>
);

export default ACResourcesPage;
